import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import { header3 } from '@westwing/ui-kit/typography';
import useTranslator from '../hooks/useTranslator';
import NotFoundImageLink from '../assets/images/404-page-image.jpg';
import NotFoundDesktopImageLink from '../assets/images/404-page-image-desktop.jpg';
import HybridLink from './Generic/Links/HybridLink';

const PageContainer = styled.div`
    background: url(${NotFoundImageLink}) no-repeat center center / cover;
    height: 86vh;
    ${forDesktop`
        background: url(${NotFoundDesktopImageLink}) no-repeat center center / cover;
        height: 713px;
    `}
`;

const MessageContainer = styled.div`
    width: 60%;
    margin: auto;
    text-align: center;
`;

const MessageHeader = styled.div`
    ${header3}
    padding-top: 15%;
    ${forDesktop`
        padding-top: 45px;
    `}
    color: ${({ theme }) => theme.colors.charcoal100};
    font-style: italic;
`;

const Message = styled.div`
    color: ${({ theme }) => theme.colors.charcoal100};
    font-size: 1.07em;
    letter-spacing: -0.3px;
    padding: 5% 0 10% 0;
    ${forDesktop`
        padding: 25px 0;
    `}
`;

const HomeLinkButton = styled.button`
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: ${({ theme }) => theme.colors.turquoise100};
    border: none;
    > a {
        color: ${({ theme }) => theme.colors.white};
        text-decoration: none;
    }
`;

const NotFound: FC = (): ReactElement => {
    const t = useTranslator();

    return (
        <>
            <PageContainer>
                <MessageContainer>
                    <MessageHeader>{t('oops_page_title')}</MessageHeader>
                    <Message>{t('this page is no more')}</Message>
                    <HomeLinkButton>
                        <HybridLink to="/">{t('Go to Home Page')}</HybridLink>
                    </HomeLinkButton>
                </MessageContainer>
            </PageContainer>
        </>
    );
};

export default NotFound;
